import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import foodbrand from "../assets/foodbrand@2x.png";

function HomeExpProfesional() {

  const navigate = useNavigate();
  const [strCPV, setStrCPV] = useState("");


  useEffect(() => {
    setStrCPV(localStorage.getItem("sCpv"));
  });

  const onTest = async () => {
    navigate("/QuestionExpProfesional", {
      state: { user: "userTest" },
    });
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/PantallaBase27"
          title="Experiencia profesional"
          name="HomeExpProfesional"
        />
        <div className="containerRender">
          <div className="containerInfo_P2">
            <div className="containerIdent_P2">
              <div className="txtOp_P2">Operación/Operation</div>
              <div className="txtVer_P2">
                Cuestionario de Experiencia Profesional
              </div>
              <div className="txtCpv_P2">CPV/PVC</div>
              <div className='txtVer_P2'>{strCPV}</div>
              <div className="txtOp_P2">Remitente/Sender</div>
              <div className="txtVer_P2">Business Prey</div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="containerCont_P2">
            <button className="button_P2" onClick={onTest}>
              <span className="txtButton_P2">Iniciar</span>
            </button>
          </div>
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeExpProfesional;